fragment TimelineFragment on timeline_Entry {
  typeHandle
  heading
  timelineSlides {
    ... on timelineSlidesBlock_Entry {
      heading
      body
      image {
        url
        title
      }
      alt
    }
  }
}
